import CommonUtil from '@/common/utils/CommonUtil'
import ApiUrlConstants from '@/common/ApiUrlConstants'
export default class JISTRDRCTService {
  /**
   * CAAA1015API処理呼出
   * @param jistDirectUrl
   */
  public async callAPICAAA1015(jistDirectUrl, xsrfToken) {
    const dataForm = [
      { name: 'jistDirectUrl', value: jistDirectUrl },
      { name: 'ACC-KEY', value: CommonUtil.createApiCallControlAccessKey() },
      { name: '_csrf', value: xsrfToken }
    ]
    const form: HTMLFormElement = CommonUtil.createForm(
      'POST',
      process.env.VUE_APP_BASE_API + ApiUrlConstants.CAAA1015,
      '_self',
      dataForm
    )
    document.body.appendChild(form)
    form.submit()
  }
}
